// Author : NANDHAKUMAR
// Version :0.0.1
// MODIFIED DATE: 14/11/2025
import { all, call, put, takeLatest } from 'redux-saga/effects';
import {
	fetchFixedDepositCollectionApproveEodDetailsFailure,
	fetchFixedDepositCollectionApproveEodDetailsResponseChanged,
	fetchFixedDepositCollectionApproveEodDetailsSuccess,
	addFixedDepositDetailsFailure,
	addFixedDepositDetailsResponseChanged,
	addFixedDepositDetailsSuccess,
	deleteFixedDepositDetailsFailure,
	deleteFixedDepositDetailsSuccess,
	deleteFixedDepositDetailsResponseChanged,
	fetchFixedDepositCollectionApproveDetailsFailure,
	fetchFixedDepositCollectionApproveDetailsResponseChanged,
	fetchFixedDepositCollectionApproveDetailsSuccess,
	getFixedDepositDetailsFailure,
	getFixedDepositDetailsSuccess,
	getFixedDepositDetailsResponseChanged,
} from './fixed-deposit.action';
import {
	fixedDepositDetailsAdd,
	fixedDepositDetailsGet,
	fixedDepositDetailsDelete,
	fixedDepositCollectionApproveDetailsGet,
	fixedDepositCollectionApproveEodDetailsGet,
} from './fixed-deposit.service';
import AlertManager from '../../../../utils/alertManager';
import { encryptData } from '../../../_common/enode-decode';
import { formatDateForApi } from './fixed-deposit.utill';
import { getEODGoldCollectionDetailsFailure } from '../../end-of-day/end-of-day.action';
import FixedDepositActionTypes from './fixed-deposit.types';

/** *********************  START GET EOD GOLD COLLECTION DETAILS  ******************** */
export function* fetchFixedDepositCollectionApproveEodDetailsList({ payload }: any) {
	try {
		const key = 'FixedDepositCollectionApproveEODKey';
		const { companyID, databaseName, fixedDepositID } = payload;
		const jsonData = {
			CompanyID: companyID,
			DatabaseName: databaseName,
			FixedDepositID: fixedDepositID,
		};
		const encodeData = encryptData(jsonData, key);
		// @ts-ignore
		const responseData = yield call(fixedDepositCollectionApproveEodDetailsGet, encodeData);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(fetchFixedDepositCollectionApproveEodDetailsFailure(responseData.data));
		} else {
			yield put(fetchFixedDepositCollectionApproveEodDetailsSuccess(responseData.data));
		}
	} catch (error) {
		yield put(getEODGoldCollectionDetailsFailure(error));
	}
}
export function* resetEODGoldCollectionDetailsResponse() {
	yield put(fetchFixedDepositCollectionApproveEodDetailsResponseChanged());
}
export function* onFetchFixedDepositCollectionApproveEodDetails() {
	yield takeLatest(
		FixedDepositActionTypes.FETCH_FIXED_DEPOSIT_COLLCTION_APPROVE_EOD_DETAILS_START,
		fetchFixedDepositCollectionApproveEodDetailsList,
	);
}
export function* onFetchFixedDepositCollectionApproveEodDetailsResponseReset() {
	yield takeLatest(
		FixedDepositActionTypes.FETCH_FIXED_DEPOSIT_COLLCTION_APPROVE_EOD_DETAILS_RESPONSE_RESET,
		resetEODGoldCollectionDetailsResponse,
	);
}
/** *********************  END GET EOD GOLD COLLECTION DETAILS ******************** */

/** *********************  START FETCH FIXED DEPOSIT COLLCTION APPROVE EOD DETAILS  ******************** */
export function* addFixedDepositCollectionApproveEodDetailsList({ payload }: any) {
	try {
		const key = 'CreateFixedDepositDetailKey';
		const {
			generalCompanyID,
			memberPhone,
			depositAmount,
			tenureType,
			tenure,
			interestRate,
			maturityDate,
			maturityAmount,
			depositDate,
			interestPayable,
			nomineeName,
			nomineeRelationShip,
			firstDepositor,
			secondDepositor,
			nextInterestPayoutDate,
			effectDate,
			userID,
			memberID,
			nextInterestPayoutAmount,
			databaseName,
		} = payload;
		const jsonData = {
			GeneralCompanyID: generalCompanyID,
			MemberPhone: memberPhone,
			DatabaseName: databaseName,
			DepositAmount: depositAmount ?? '0',
			TenureType: tenureType ?? '0',
			Tenure: tenure ?? '0',
			InterestRate: interestRate ?? '0',
			MaturityDate: formatDateForApi(maturityDate),
			MaturityAmount: maturityAmount ?? '0',
			DepositDate: formatDateForApi(depositDate),
			InterestPayable: interestPayable ?? '0',
			NomineeName: nomineeName ?? '0',
			NomineeRelationship: nomineeRelationShip ?? '0',
			FirstDepositor: firstDepositor ?? '0',
			SecondDepositor: secondDepositor ?? '0',
			NextInterestPayoutDate: formatDateForApi(nextInterestPayoutDate),
			NextInterestPayoutAmount: nextInterestPayoutAmount ?? '0',
			EffectDate: formatDateForApi(effectDate),
			CreatedBy: userID,
			MemberID: memberID,
		};
		const encodeData = encryptData(jsonData, key);
		// @ts-ignore
		const responseData = yield call(fixedDepositDetailsAdd, encodeData);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(addFixedDepositDetailsFailure(responseData.data));
		} else {
			yield put(addFixedDepositDetailsSuccess(responseData.data));
		}
	} catch (error) {
		yield put(addFixedDepositDetailsFailure(error));
	}
}
export function* resetAddFixedDepositDetailsResponse() {
	yield put(addFixedDepositDetailsResponseChanged());
}
export function* onAddFixedDepositDetails() {
	yield takeLatest(
		FixedDepositActionTypes.ADD_FIXED_DEPOSIT_DETAILS_START,
		addFixedDepositCollectionApproveEodDetailsList,
	);
}
export function* onResetAddFixedDepositDetails() {
	yield takeLatest(
		FixedDepositActionTypes.ADD_FIXED_DEPOSIT_DETAILS_RESPONSE_RESET,
		resetAddFixedDepositDetailsResponse,
	);
}
/** *********************  END ADD FIXED DEPOSIT DETAILS ******************** */

/** *********************  START DELETE FIXED DEPOSIT DETAILS  ******************** */
export function* deleteFixedDepositDetailsList({ payload }: any) {
	try {
		const key = 'FixedDepositEODDeleteKey';
		const { companyID, databaseName, userID, fixedDepositID } = payload;
		const jsonData = {
			CompanyID: companyID,
			DatabaseName: databaseName,
			CreatedBy: userID,
			FixedDepositID: fixedDepositID,
		};
		const encodeData = encryptData(jsonData, key);
		// @ts-ignore
		const responseData = yield call(fixedDepositDetailsDelete, encodeData);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(deleteFixedDepositDetailsFailure(responseData.data));
		} else {
			yield put(deleteFixedDepositDetailsSuccess(responseData.data));
		}
	} catch (error) {
		yield put(deleteFixedDepositDetailsFailure(error));
	}
}
export function* resetDeleteFixedDepositDetailsResponse() {
	yield put(deleteFixedDepositDetailsResponseChanged());
}
export function* onDeleteFixedDepositDetails() {
	yield takeLatest(
		FixedDepositActionTypes.DELETE_FIXED_DEPOSIT_DETAILS_START,
		deleteFixedDepositDetailsList,
	);
}
export function* onResetDeleteFixedDepositDetails() {
	yield takeLatest(
		FixedDepositActionTypes.DELETE_FIXED_DEPOSIT_DETAILS_RESPONSE_RESET,
		resetDeleteFixedDepositDetailsResponse,
	);
}
/** *********************  END DELETE FIXED DEPOSIT DETAILS ******************** */

/** *********************  START FIXED DEPOSIT COLLCTION APPROVAL SAGA  ******************** */
export function* fetchFixedDepositCollectionApproveDetailsList({ payload }: any) {
	try {
		const key = 'FixedDepositCollectionApproveKey';
		const { companyID, databaseName, fixedDepositID, userID } = payload;
		const jsonData = {
			CompanyID: companyID,
			DatabaseName: databaseName,
			FixedDepositID: fixedDepositID,
			ApprovedBy: userID,
		};
		const encodeData = encryptData(jsonData, key);
		// @ts-ignore
		const responseData = yield call(fixedDepositCollectionApproveDetailsGet, encodeData);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(fetchFixedDepositCollectionApproveDetailsFailure(responseData.data));
		} else {
			yield put(fetchFixedDepositCollectionApproveDetailsSuccess(responseData.data));
		}
	} catch (error) {
		yield put(fetchFixedDepositCollectionApproveDetailsFailure(error));
	}
}
export function* resetFetchFixedDepositCollectionApproval() {
	yield put(fetchFixedDepositCollectionApproveDetailsResponseChanged());
}
export function* onFetchFixedDepositCollectionApproval() {
	yield takeLatest(
		FixedDepositActionTypes.FETCH_FIXED_DEPOSIT_COLLCTION_APPROVAL_DETAILS_START,
		fetchFixedDepositCollectionApproveDetailsList,
	);
}
export function* onResetFetchFixedDepositCollectionApproval() {
	yield takeLatest(
		FixedDepositActionTypes.FETCH_FIXED_DEPOSIT_COLLCTION_APPROVAL_DETAILS_RESPONSE_RESET,
		resetFetchFixedDepositCollectionApproval,
	);
}
/** *********************  END FIXED DEPOSIT COLLCTION APPROVAL SAGA  ******************** */

/** *********************  START FIXED DEPOSIT SAGA  ******************** */
export function* fetchFixedDepositDetailsList({ payload }: any) {
	try {
		const key = 'GetMemberFixedDepositKey';
		const { companyID, databaseName, memberID } = payload;
		const jsonData = {
			CompanyID: companyID,
			DatabaseName: databaseName,
			MemberID: memberID,
		};
		const encodeData = encryptData(jsonData, key);
		// @ts-ignore
		const responseData = yield call(fixedDepositDetailsGet, encodeData);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(getFixedDepositDetailsFailure(responseData.data));
		} else {
			yield put(getFixedDepositDetailsSuccess(responseData.data));
		}
	} catch (error) {
		yield put(getFixedDepositDetailsFailure(error));
	}
}
export function* resetFetchFixedDepositDetails() {
	yield put(getFixedDepositDetailsResponseChanged());
}
export function* onFetchFixedDepositDetails() {
	yield takeLatest(
		FixedDepositActionTypes.GET_FIXED_DEPOSIT_DETAILS_START,
		fetchFixedDepositDetailsList,
	);
}
export function* onResetFetchFixedDepositDetails() {
	yield takeLatest(
		FixedDepositActionTypes.GET_FIXED_DEPOSIT_DETAILS_RESPONSE_RESET,
		resetFetchFixedDepositDetails,
	);
}
/** *********************  END FIXED DEPOSIT SAGA  ******************** */

export function* fixedDepositSaga() {
	yield all([
		call(onFetchFixedDepositCollectionApproveEodDetails),
		call(onFetchFixedDepositCollectionApproveEodDetailsResponseReset),
		call(onAddFixedDepositDetails),
		call(onResetAddFixedDepositDetails),
		call(onDeleteFixedDepositDetails),
		call(onResetDeleteFixedDepositDetails),
		call(onFetchFixedDepositCollectionApproval),
		call(onResetFetchFixedDepositCollectionApproval),
		call(onFetchFixedDepositDetails),
		call(onResetFetchFixedDepositDetails),
	]);
}
